export const FETCH_MASTER_DATA_REQUEST = 'FETCH_MASTER_DATA_REQUEST'
export const FETCH_MASTER_DATA_SUCCESS = 'FETCH_MASTER_DATA_SUCCESS'

export const fetchMasterData = () => {
  return {
    type: FETCH_MASTER_DATA_REQUEST,
  }
}
